/** @format */

import { TJustificativeStatus } from "../declarations/maps/justificatives";
import { TStore } from "../declarations/store";

export const selectorJustificativeStatusesList = (store: TStore): TJustificativeStatus[] =>
  store.justificativeStatuses.justificativeStatusList || [];
